export const cursorTextVariants ={
    initial:{
        transition: {
            staggerChildren: 0.04
        }
    },
    animate:{
        transition: {
            delay: 0.1,
            staggerChildren: 0.05
        }
    },
    exit:{
        transition: {
            staggerChildren: 0.05
        }
    },
}

export const cursorCircleVariants ={
    initial: {
      opacity: 0,
      transition: {
        duration: 0.25,
      }
  },
  animate: {
      opacity: 1,
      transition: {
          duration: 1,
          ease: [0.33, 1, 0.68, 1],
          transform: {
            duration: 0.25,
            ease: "easeOut"
          }
      }
  },
  exit: {
      opacity: 0,
      transition: {
          duration: 0.45,
          ease: [0.33, 1, 0.68, 1],
          transform:{
            duration: 0.45,
            ease: [0.33, 1, 0.68, 1]
          }
      }

  }
}

export const cursorCharVariants = {
    initial: {
        transform: "translate3d(0px, 100%, 0px)",
        opacity: 1
    },
    animate: {
        transform: "translate3d(0px, 0%, 0px)",
        opacity: 1,
        transition: {
            duration: 0.5,
            ease: [0.16, 1, 0.3, 1]
        }
    },
    exit: {
        transform: "translate3d(0px, 100%, 0px)",
        opacity: 1,
        transition: {
            duration: 0.5,
            ease: [0.7, 0, 0.84, 0]
        }

    }
}